import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { CertificationExam } = await import('./index');
    return {
        Component: CertificationExam,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
